import { orderApi } from "./order.api";

export const {
  useGetOrdersQuery,
  useListOrdersInfiniteQuery,
  useGetOrderQuery,
  useGetOrderHasDriverQuery,
  useLazyGetOrderHasDriverQuery,
  useCreateOrderMutation,
  useSaveOrderMutation,
  useEditOrderMutation,
  useDeleteOrderMutation,
  useSearchOrdersQuery,
  useLazySearchOrdersQuery
} = orderApi;
